import { useContext, useEffect, useState } from "react";
import usePopup from "../../../hooks/usePopup";
import { Button, CircularProgress, IconButton, Tooltip } from "@mui/material";
import { LabContext } from ".";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import dayjs from "dayjs";
import useSaveLabResult from "../hook/useSaveLabResult";
export const dateFormat = "YYYY-MM-DD HH:mm:ss"; // eg 2025-05-02 17:28:10
function SaveSpecimendate() {
  const [selectedDate, setSelectedDate] = useState<string>("");
  const [open, setOpen] = useState(false);
  const { setLabData, labData, isResultSaved } = useContext(LabContext);
  const { CustomModal } = usePopup();
  const handleOpen = () => {
    setOpen(true);
  };
  const onSuccess = () => {
    setOpen(false);
  };
  const { mutate: save, isLoading: saveLoading } = useSaveLabResult(onSuccess);

  const handleSave = () => {
    const updated = [...labData.data];
    updated.forEach((_, index) => {
      updated[index].specimenReceivedDateTime = selectedDate;
    });
    if (isResultSaved) {
      setLabData({ specimenReceivedDateTime: selectedDate, data: updated });
      save(updated);
    } else {
      setLabData({ specimenReceivedDateTime: selectedDate, data: updated });
      setOpen(false);
    }
  };
  const handleOnChange = (value: any, _: any) => {
    const date = dayjs(value).format(dateFormat);
    setSelectedDate(date);
  };

  useEffect(() => {
    setSelectedDate(labData.specimenReceivedDateTime || dayjs().format(dateFormat));
  }, [labData.specimenReceivedDateTime]);
  return (
    <>
      <CustomModal
        open={open}
        setOpen={setOpen}
        title="Select specimen received date"
      >
        <div className="w-[40vw] px-2 py-4">
          <div className=" h-[40dvh]">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker
                minutesStep={1}
                defaultValue={
                  selectedDate
                    ? dayjs(dayjs(selectedDate, dateFormat), dateFormat)
                    : dayjs()
                }
                onChange={handleOnChange}
                format="DD-MM-YYYY hh:mm A"
                label="Select date"
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock,
                }}
              />
            </LocalizationProvider>
          </div>
          <div className="pt-4 flex justify-end">
            <Button
              disabled={saveLoading}
              endIcon={
                saveLoading && <CircularProgress size={18} color="success" />
              }
              color="success"
              onClick={handleSave}
            >
              save
            </Button>
          </div>
        </div>
      </CustomModal>
      <Tooltip title="Select specimen received date">
        <IconButton onClick={handleOpen}>
          <CalendarMonthIcon color="primary" />
        </IconButton>
      </Tooltip>
    </>
  );
}

export default SaveSpecimendate;
